<template>
    <div id="packer_selected_pack">
        <div class="ui card">
            <div class="content">
                <h2 class="ui header">
                    <i class="info circle icon"></i>
                    <div class="content">
                        選擇中的包裹
                    </div>
                </h2>
            </div>
            <div class="content">
                <table class="ui celled table" v-if="Object.keys(selected_pack).length > 0">
                    <thead>
                        <tr>
                            <th class="six wide center aligned">欄位</th>
                            <th class="ten wide center aligned">內容</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="center aligned">號碼</td>
                            <td class="center aligned">{{ selected_pack.core_waybill_number }}</td>
                        </tr>
                        <tr>
                            <td class="center aligned">親包號碼</td>
                            <td class="center aligned">
                                <span v-if="parent_pack">
                                    {{ parent_pack.core_waybill_number }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="ui icon message">
                    <i class="question icon"></i>
                    <div class="content">
                        <div class="header">
                            尚未選擇任何包
                        </div>
                        <p>點選左上角指令列的"{{ $t("packer.selection") }}"開始作業</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        selected_pack: Object,
        parent_pack: Object,
    },
    data: function() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
    },
    components: {
    }
}
</script>
